import { render, staticRenderFns } from "./SocietyMatchesWizardView.vue?vue&type=template&id=034371c4&scoped=true"
import script from "./SocietyMatchesWizardView.vue?vue&type=script&lang=js"
export * from "./SocietyMatchesWizardView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034371c4",
  null
  
)

export default component.exports